import { render, staticRenderFns } from "./PaymentRulesPanel.vue?vue&type=template&id=294a8cb4&"
import script from "./PaymentRulesPanel.vue?vue&type=script&lang=js&"
export * from "./PaymentRulesPanel.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRulesPanel.vue?vue&type=style&index=0&id=294a8cb4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports